import React from "react";
// @ts-ignore
import verticalProjects from "../content/vertical";
import { RiArrowLeftSLine, RiPlayFill, RiArrowRightSLine } from "react-icons/ri";
import { useAtom } from "jotai";
import { videoAtom, videoModalAtom } from "../atoms";

export function ProjectsVerticalSection({ active }: { active: boolean }) {
  const [activeProjectIndex, setActiveProjectIndex] = React.useState<number | null>(null);
  const [_, setVideo] = useAtom(videoAtom);
  const [__, setVideoModal] = useAtom(videoModalAtom);

  const onProjectHover = (project) => {
    setVideo({
      src: project.video,
      instant: false,
      props: {},
    });
  };

  React.useEffect(() => {
    if (!active) setActiveProjectIndex(null);
  }, [active]);

  if (!active) return null;

  return (
    <section className="scene-section projects-vertical-section">
      {activeProjectIndex === null && (
        <ul className="projects-list projects-list-vertical">
          {verticalProjects.map((project, i) => (
            <li key={project.title}
                onMouseEnter={() => onProjectHover(project)}
            >
              <button
                className="project-button"
                onClick={() => setActiveProjectIndex(i)}
              >
                <RiArrowRightSLine className="project-arrow" />
                <span>{project.title}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
      {activeProjectIndex !== null && (
        <div className="single-project">
          <div>
            <button
              onClick={() => setActiveProjectIndex(null)}
              className="project-back-button"
            >
              <RiArrowLeftSLine />
              Alle projecten
            </button>
          </div>
          <h2>{verticalProjects[activeProjectIndex].title}</h2>
          <p className="muted" style={{ whiteSpace: "pre-line" }}>
            {verticalProjects[activeProjectIndex].description}
          </p>
          <div>
            {verticalProjects[activeProjectIndex].fullVideo && (
              <button
                className="play-button"
                style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
                onClick={() => setVideoModal(verticalProjects[activeProjectIndex].fullVideo)}
              >
                <RiPlayFill />
                <span>Bekijk video</span>
              </button>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
